import getStyles from "./styles";
import { Grid } from "@mui/material";

export default function _Splitter() {
  const styles = getStyles();
  return <Grid item xs={false} sm={false} md={true} sx={styles.root} />;
}
